import WomanLeader from "../../../assets/images/png/mba/mba-leader-woman-v1.png";
import ManLeader from "../../../assets/images/png/mba/mba-leader-man-v1.png";
import HijabLeader from "../../../assets/images/png/mba/mba-leader-hijab-v1.png";
import TechImage from "../../../assets/images/png/mba/mba-hero-v3.jpg";

export const scholarshipCategories = [
  {
    id: "professional-women",
    dropdownLabel: "Professional Women Scholarship",
    cardTitle: "Professional Women",
    percent: "50%",
    image: WomanLeader,
    cardAlt: "Smiling African woman business professional",
    heroAlt:
      "Smiling African woman professional ready to grow into a stronger business leader",
    copy:
      "For professional women building and leading careers across industries.",
  },
  {
    id: "working-professionals",
    dropdownLabel: "Professionals Scholarship",
    cardTitle: "Working Professionals",
    percent: "25%",
    image: ManLeader,
    cardAlt: "African man business professional in a navy suit",
    heroAlt:
      "African man business professional preparing for leadership growth",
    copy:
      "For professionals accelerating their careers and moving into stronger business and leadership roles.",
  },
  {
    id: "technology-professionals",
    dropdownLabel: "Technology Professionals Scholarship",
    cardTitle: "Technology Professionals",
    percent: "25%",
    image: TechImage,
    cardAlt: "African technology professionals collaborating around a laptop",
    heroAlt: "African technology professionals collaborating around a laptop",
    copy:
      "For technology professionals preparing for engineering management, technology leadership and CTO-level roles.",
  },
  {
    id: "africans-in-diaspora",
    dropdownLabel: "Africans in Diaspora Scholarship",
    cardTitle: "Africans in Diaspora",
    percent: "25%",
    image: HijabLeader,
    cardAlt: "African Muslim woman business professional in a navy suit",
    heroAlt:
      "African Muslim woman professional building a global leadership career",
    copy:
      "For African professionals living and building careers across the world.",
  },
];

export const getScholarshipById = (id) =>
  scholarshipCategories.find((item) => item.id === id) ||
  scholarshipCategories[0];
